import { render, staticRenderFns } from "./addDiscount.vue?vue&type=template&id=c646b7b2"
import script from "./addDiscount.vue?vue&type=script&lang=js"
export * from "./addDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports